import React from "react";
import { EligibilitySummaryReportsContainer } from "../../../containers";

const EligibilitySummaryReports = (props) => {
  return (
    <EligibilitySummaryReportsContainer
      menu="eligibility"
      subMenu="eligibilitySummaryReports"
      {...props}
    />
  );
};

export default EligibilitySummaryReports;
